/* Persona PDP: variant selection, price sync, gallery dots, sticky bar. */
(function () {
  function init(root) {
    if (root.dataset.ppdpReady) return;
    root.dataset.ppdpReady = '1';

    var blob = root.querySelector('[data-ppdp-variants]');
    if (!blob) return;
    var variants;
    try {
      variants = JSON.parse(blob.textContent);
    } catch (e) {
      return;
    }

    var idInput = root.querySelector('[data-ppdp-id]');
    var groups = [].slice.call(root.querySelectorAll('[data-ppdp-opt]'));
    var engrave = root.querySelector('[data-ppdp-engrave]');
    var engraveInput = engrave && engrave.querySelector('input');
    var atc = root.querySelector('[data-ppdp-atc]');
    var atcPrice = root.querySelector('[data-ppdp-atc-price]');
    var stickyAtc = root.querySelector('[data-ppdp-sticky-atc]');

    // One selected value per product option, keyed by option index.
    var sel = [];
    var personalIndex = -1;

    groups.forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-ppdp-opt'), 10);
      var chosen = null;
      group.querySelectorAll('.ppdp__pill').forEach(function (p) {
        if (p.getAttribute('aria-pressed') === 'true') chosen = p.dataset.value;
      });
      group.querySelectorAll('.ppdp__opt').forEach(function (o) {
        if (o.dataset.selected === 'true') chosen = o.dataset.value;
        personalIndex = idx;
      });
      if (chosen === null) {
        var first = group.querySelector('.ppdp__pill, .ppdp__opt');
        if (first) chosen = first.dataset.value;
      }
      sel[idx] = chosen;
    });

    function money(cents) {
      return (
        '$' +
        (cents / 100).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );
    }

    function match() {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var n = 0; n < sel.length; n++) {
          if (sel[n] != null && v.options[n] !== sel[n]) {
            ok = false;
            break;
          }
        }
        if (ok) return v;
      }
      return null;
    }

    function setText(selector, value) {
      var el = root.querySelector(selector);
      if (el) el.textContent = value;
    }

    function render() {
      var v = match();
      if (!v) return;
      if (idInput) idInput.value = v.id;

      setText('[data-ppdp-price]', money(v.price));
      setText('[data-ppdp-sticky-price]', money(v.price));
      if (atcPrice) atcPrice.textContent = money(v.price);

      var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
      ['[data-ppdp-compare]', '[data-ppdp-sticky-compare]'].forEach(function (s) {
        var el = root.querySelector(s);
        if (!el) return;
        el.textContent = hasCompare ? money(v.compare_at_price) : '';
        el.style.display = hasCompare ? '' : 'none';
      });
      var save = root.querySelector('[data-ppdp-save]');
      if (save) {
        save.textContent = hasCompare
          ? 'SAVE ' + money(v.compare_at_price - v.price).replace(/\.00$/, '')
          : '';
        save.style.display = hasCompare ? '' : 'none';
      }

      [atc, stickyAtc].forEach(function (b) {
        if (b) b.disabled = !v.available;
      });
      var label = root.querySelector('[data-ppdp-atc-text]');
      if (label && !v.available) label.textContent = 'Sold out';

      // Engraving text box only for options that actually accept characters.
      if (engrave) {
        var chosen = personalIndex > -1 ? sel[personalIndex] || '' : '';
        var wantsText = /character/i.test(chosen) && !/^no\b/i.test(chosen);
        engrave.hidden = !wantsText;
        if (engraveInput) {
          engraveInput.disabled = !wantsText;
          if (!wantsText) {
            engraveInput.value = '';
          } else {
            var m = chosen.match(/(\d+)\s*-\s*(\d+)/);
            engraveInput.maxLength = m ? parseInt(m[2], 10) : 10;
          }
        }
      }
    }

    groups.forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-ppdp-opt'), 10);
      var pillList = [].slice.call(group.querySelectorAll('.ppdp__pill'));
      pillList.forEach(function (p) {
        p.addEventListener('click', function () {
          sel[idx] = p.dataset.value;
          pillList.forEach(function (q) {
            q.setAttribute('aria-pressed', q === p ? 'true' : 'false');
          });
          render();
        });
      });

      var optList = [].slice.call(group.querySelectorAll('.ppdp__opt'));
      optList.forEach(function (o) {
        o.addEventListener('change', function () {
          sel[idx] = o.dataset.value;
          optList.forEach(function (q) {
            q.dataset.selected = q === o ? 'true' : 'false';
          });
          syncPanels();
          render();
        });
      });
    });

    // The detail box under the option list shows the panel the selection needs.
    function syncPanels() {
      var box = root.querySelector('[data-ppdp-infobox]');
      if (!box) return;
      var chosen = root.querySelector('.ppdp__opt[data-selected="true"]');
      var kind = chosen ? chosen.dataset.kind : 'none';
      var max = chosen && chosen.dataset.max ? parseInt(chosen.dataset.max, 10) : 10;

      var open = kind === 'text' || kind === 'logo';
      box.classList.toggle('is-open', open);
      box.setAttribute('aria-hidden', open ? 'false' : 'true');

      box.querySelectorAll('[data-ppdp-panel]').forEach(function (panel) {
        var on = panel.getAttribute('data-ppdp-panel') === kind;
        panel.hidden = !on;
        panel.querySelectorAll('input, textarea').forEach(function (field) {
          field.disabled = !on;
          if (!on) {
            field.value = '';
            if (field.type === 'file') {
              var nm = panel.querySelector('[data-ppdp-file-name]');
              if (nm) nm.textContent = 'Choose image';
            }
          }
        });
      });

      var input = box.querySelector('[data-ppdp-engrave-input]');
      var count = box.querySelector('[data-ppdp-count]');
      var label = box.querySelector('[data-ppdp-text-label]');
      if (kind === 'text' && input) {
        input.maxLength = max;
        if (label) label.textContent = 'Enter your text (1\u2013' + max + ' characters)';
        if (count) count.textContent = input.value.length + '/' + max;
      }
      // Hidden inputs submit even inside a hidden panel, so the font property
      // is emptied unless text engraving is actually the chosen option.
      // Shopify drops blank line item properties.
      var fontInput = box.querySelector('[data-ppdp-font-input]');
      var fontGroup = box.querySelector('[data-ppdp-fonts]');
      if (fontInput) {
        fontInput.value = kind === 'text'
          ? (fontGroup && fontGroup.dataset.ppdpFontChosen) || fontInput.value
          : '';
      }
      if (kind !== 'text') {
        var pv = box.querySelector('[data-ppdp-preview]');
        if (pv) pv.textContent = '';
      }
      if (kind !== 'logo') {
        var nc = box.querySelector('[data-ppdp-notes-count]');
        if (nc) nc.textContent = '0/100';
      }
    }

    // Live character count + engraving preview
    root.querySelectorAll('[data-ppdp-engrave-input]').forEach(function (input) {
      var box = input.closest('[data-ppdp-infobox]');
      var count = box && box.querySelector('[data-ppdp-count]');
      var preview = box && box.querySelector('[data-ppdp-preview]');
      input.addEventListener('input', function () {
        var max = input.maxLength > 0 ? input.maxLength : 10;
        if (count) count.textContent = input.value.length + '/' + max;
        if (preview) preview.textContent = input.value;
      });
    });

    // Engraving font. Clicking a chip restyles the plate preview and records
    // the choice as a line item property for the engraver.
    root.querySelectorAll('[data-ppdp-fonts]').forEach(function (group) {
      var box = group.closest('[data-ppdp-infobox]');
      var preview = box && box.querySelector('[data-ppdp-preview]');
      var hidden = box && box.querySelector('[data-ppdp-font-input]');
      var chips = Array.prototype.slice.call(group.querySelectorAll('[data-ppdp-font]'));

      function pick(chip) {
        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        if (preview) preview.setAttribute('data-font', chip.getAttribute('data-ppdp-font'));
        // Remember the name even while the property is cleared, so switching
        // away from engraving and back restores the shopper's choice.
        var name = chip.getAttribute('data-ppdp-font-name') || '';
        group.dataset.ppdpFontChosen = name;
        if (hidden && hidden.value !== '') hidden.value = name;
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          pick(chip);
        });
        chip.addEventListener('keydown', function (event) {
          var i = chips.indexOf(chip);
          var next = null;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = chips[(i + 1) % chips.length];
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = chips[(i - 1 + chips.length) % chips.length];
          else return;
          event.preventDefault();
          pick(next);
          next.focus();
        });
      });

      var active = group.querySelector('[data-ppdp-font].is-active') || chips[0];
      if (active) group.dataset.ppdpFontChosen = active.getAttribute('data-ppdp-font-name') || '';
    });

    root.querySelectorAll('[data-ppdp-notes]').forEach(function (area) {
      var box = area.closest('[data-ppdp-infobox]');
      var count = box && box.querySelector('[data-ppdp-notes-count]');
      area.addEventListener('input', function () {
        if (count) count.textContent = area.value.length + '/100';
      });
    });

    root.querySelectorAll('[data-ppdp-file]').forEach(function (file) {
      var box = file.closest('[data-ppdp-infobox]');
      var name = box && box.querySelector('[data-ppdp-file-name]');
      file.addEventListener('change', function () {
        if (!name) return;
        if (file.files && file.files[0]) {
          var f = file.files[0];
          if (f.size > 5 * 1024 * 1024) {
            name.textContent = 'File too large (max 5MB)';
            file.value = '';
            return;
          }
          name.textContent = f.name;
        } else {
          name.textContent = 'Choose image';
        }
      });
    });

    syncPanels();

    // Perspective depth tracks the rendered plate so the tilt holds at any size.
    function sizePerspective() {
      root.querySelectorAll('.ppdp__plate').forEach(function (plate) {
        var w = plate.getBoundingClientRect().width;
        if (w) plate.style.setProperty('--ppdp-persp', (w * 0.64).toFixed(1) + 'px');
      });
    }
    sizePerspective();
    window.addEventListener('resize', sizePerspective);

    /*
      Gallery: thumbnails, arrows, counter and the zoom link all read from one
      notion of "which slide is showing". The track is scroll-snapped, so the
      scroll position is the source of truth and every control either moves it
      or reflects it.
    */
    var slides = root.querySelector('[data-ppdp-slides]');
    var slideEls = slides ? [].slice.call(slides.querySelectorAll('[data-ppdp-slide]')) : [];
    if (slides && slideEls.length > 1) {
      var thumbs = [].slice.call(root.querySelectorAll('[data-ppdp-thumbs] .ppdp__thumb'));
      var prevBtn = root.querySelector('[data-ppdp-prev]');
      var nextBtn = root.querySelector('[data-ppdp-next]');
      var counter = root.querySelector('[data-ppdp-counter]');
      var zoom = root.querySelector('.ppdp__zoom');
      var current = 0;

      // The track carries a gap between slides, so a slide's position is read
      // from the DOM rather than assumed to be index × track width.
      function indexFromScroll() {
        var x = slides.scrollLeft;
        var best = 0;
        var bestGap = Infinity;
        slideEls.forEach(function (el, i) {
          var gap = Math.abs(el.offsetLeft - slides.offsetLeft - x);
          if (gap < bestGap) { bestGap = gap; best = i; }
        });
        return best;
      }

      // Set while the gallery is moving itself, so a programmatic jump (a
      // thumbnail click can span the whole strip) is never mistaken for a
      // swipe and clamped.
      var programmatic = false;
      // The index the current gesture started from, or null between gestures.
      var gestureFrom = null;

      function scrollToIndex(i, smooth) {
        var el = slideEls[i];
        if (!el) return;
        programmatic = true;
        slides.scrollTo({
          left: el.offsetLeft - slides.offsetLeft,
          behavior: smooth === false ? 'auto' : 'smooth'
        });
      }

      // The controls update the moment they are used, rather than waiting for
      // the smooth scroll to land. Otherwise a second click arriving mid-flight
      // steps from the old position and the gallery jumps backwards.
      function goTo(i, smooth) {
        if (!slideEls[i]) return;
        gestureFrom = null;
        sync(i);
        scrollToIndex(i, smooth);
      }

      function sync(i) {
        current = i;
        thumbs.forEach(function (t, n) {
          var on = n === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          // Only the selected thumbnail stays in the tab order, so Tab moves
          // past the strip rather than through every image.
          t.setAttribute('tabindex', on ? '0' : '-1');
        });
        if (thumbs[i] && thumbs[i].scrollIntoView) {
          thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
        if (prevBtn) prevBtn.disabled = i === 0;
        if (nextBtn) nextBtn.disabled = i === slideEls.length - 1;
        if (counter) counter.textContent = i + 1 + '/' + slideEls.length;
        // Zoom should open whatever the shopper is looking at, not always the
        // featured image.
        var full = slideEls[i].getAttribute('data-zoom');
        if (zoom && full) zoom.setAttribute('href', full);
      }

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          goTo(parseInt(t.dataset.index, 10));
        });
        t.addEventListener('keydown', function (event) {
          var i = parseInt(t.dataset.index, 10);
          var next = null;
          if (event.key === 'ArrowRight') next = Math.min(i + 1, slideEls.length - 1);
          else if (event.key === 'ArrowLeft') next = Math.max(i - 1, 0);
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = slideEls.length - 1;
          else return;
          event.preventDefault();
          goTo(next);
          if (thumbs[next]) thumbs[next].focus();
        });
      });

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(Math.max(current - 1, 0)); });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        goTo(Math.min(current + 1, slideEls.length - 1));
      });

      /*
        One swipe moves at most one image, however hard it is flicked.

        `scroll-snap-stop: always` in the stylesheet does this natively where
        it is supported, by refusing to let momentum carry past a snap point.
        This is the backstop for browsers that ignore it, and for a slow drag
        that crosses several slides while the finger is still down: remember
        which image the gesture began on, and once the scroll settles, pull it
        back to at most one image either side.
      */
      ['touchstart', 'pointerdown', 'wheel'].forEach(function (evt) {
        slides.addEventListener(
          evt,
          function () {
            if (programmatic) return;
            if (gestureFrom === null) gestureFrom = current;
          },
          { passive: true }
        );
      });

      var scrollTimer = null;
      function onSettle() {
        var landed = indexFromScroll();

        if (!programmatic && gestureFrom !== null) {
          var clamped = Math.max(gestureFrom - 1, Math.min(gestureFrom + 1, landed));
          if (clamped !== landed) {
            // Overshot: correct to the neighbouring image and let that scroll
            // settle on its own before clearing the gesture.
            sync(clamped);
            scrollToIndex(clamped);
            return;
          }
        }

        programmatic = false;
        gestureFrom = null;
        if (landed !== current) sync(landed);
      }

      slides.addEventListener(
        'scroll',
        function () {
          // Settle first: mid-swipe the nearest slide flips back and forth, and
          // scrolling the thumbnail strip on every frame fights the gesture.
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(onSettle, 90);
        },
        { passive: true }
      );

      window.addEventListener('resize', function () {
        goTo(current, false);
      });

      sync(0);
    }

    // Sticky bar appears once the inline button scrolls away.
    var sticky = root.querySelector('[data-ppdp-sticky]');
    if (sticky && atc && window.IntersectionObserver) {
      new IntersectionObserver(
        function (entries) {
          sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
        },
        { rootMargin: '0px 0px -80px 0px' }
      ).observe(atc);
    }

    render();
  }

  function boot() {
    document.querySelectorAll('[data-ppdp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
